var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-invalid-feedback',{staticClass:"feedback",attrs:{"force-show":_vm.show}},_vm._l((_vm.validation.$errors),function(m){return _c('div',{key:m.$uid},[_vm._v(_vm._s(_vm.T(m.$message)))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }